import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-animation-dialog',
    templateUrl: './animation-dialog.component.html',
    styleUrls: ['./animation-dialog.component.scss'],
    standalone: false
})
export class AnimationDialogComponent {
	mode: string = 'alert';
	closeTimer;

	constructor(
		public dialogRef: MatDialogRef<AnimationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		if (this.data.audio) {
			var audio = new Audio(this.data.audio);
			audio.play();
		}

		if (this.data.closeTimeout) this.closeTimer = setTimeout(() => { this.close() }, this.data.closeTimeout)
	}

	close() {
		clearTimeout(this.closeTimer);
		this.dialogRef.close();
	}


}
